<template>
	<div class="landing-award-list">
		<inline-svg :src="require('@/assets/social-proof/app-store-rating.svg')" />

		<inline-svg :src="require('@/assets/social-proof/medtech-award.svg')" />

		<inline-svg :src="require('@/assets/social-proof/amount-happy-users.svg')" />
	</div>
</template>

<script>
export default {
	name: 'LandingAwardList',
}
</script>

<style lang="scss" scoped>
.landing-award-list {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 8px 0 24px 0;
}
</style>
